import { getFilters } from '@src/api/filters';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import { useQuery } from '@tanstack/react-query';

const useGetFilters = () => {
  return useQuery(
    ['saved-filters'],
    () => {
      return getFilters();
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      enabled: true,
      staleTime: 5 * 60 * 1000, // 5m
      placeholderData: [],
      onError: (err) => {
        trackQueryError({ type: 'load-saved-filters', err });
      },
    },
  );
};

export default useGetFilters;
